import styled from "styled-components";
import { colors, typography } from "@streeteasy/design-system";

const { TEXT_SECONDARY } = colors;
const { Caps } = typography;

export const TriggerTitle = styled(Caps).attrs({
  as: "span"
})`
  color: ${TEXT_SECONDARY};
  margin: 4px 0 3px;
`;
